import * as React from "react";
import { Icon } from "../actions/Icon";

/**
 * Recorder capture-mode tile (Full screen, Window, Region, Camera only, Screen + camera).
 */
export interface ModeTileProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  label: React.ReactNode;
  selected?: boolean;
  compact?: boolean;
}

export function ModeTile({ icon, label, selected, compact, className, ...rest }: ModeTileProps): JSX.Element {
  return (
    <button
      type="button"
      aria-pressed={!!selected}
      className={["gk-mode", compact && "gk-mode--compact", className].filter(Boolean).join(" ")}
      {...rest}
    >
      <Icon name={icon} size={compact ? 22 : 26} />
      <span>{label}</span>
    </button>
  );
}
